import React from 'react';
import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import Cache from 'i18next-localstorage-cache';
import sprintf from 'i18next-sprintf-postprocessor';
import {initReactI18next } from "react-i18next";

let { default_language, languages } = window.NTLF_CONFIG.portal.locale;
default_language = default_language.replace("_", "-");

const lang = window.NTLF_CONFIG.user.lang.replace("_", "-");
languages = [lang];

// Support for ntlf {{description}} context for translations. Requires skipInterpolation to be set:
const ntlfContext = {
    type: 'postProcessor',
    name: 'ntlf-context',
    process: function (value, key, options, translator) {
        // Only used if skipInterpolation:
        if (options.skipInterpolation) {
            return value.replace(/\s*\{\{.+\}\}/, "");
        }
        else {
            return value;
        }
    }
}



i18n
    .use(XHR)
    .use(Cache)
    .use(sprintf)
    .use(initReactI18next)
    .use(ntlfContext)
    .init({
        debug: true,
        ns: ['epmsmobile', 'epmsweb', 'phplibepms'],
        defaultNS: 'epmsmobile',
        fallbackNS: 'epmsweb',
        lngWhiteList: languages,
        lng: lang,
        load: 'currentOnly',
        // Use key as fallback (We need this to be english)
        fallbackLng:'en_GB',
        backend: {
            loadPath:'/locale/{{lng}}/{{ns}}.json',
            resGetPath: '/locale/{{lng}}/{{ns}}.json',
            addPath: (a, b, c) => {
              //'/locale/add_translation.php?lng={{lng}}&&ns={{ns}}'
              console.log('Add path', a, b, c);
              return '/locale/add_translation.php?lng={{lng}}&&ns={{ns}}'
            },
            allowMultiLoading: false
        },
        saveMissing: false,
        missingKeyHandler: (lng, ns, key, fallbackValue) => {
          window.TRANSLATIONS = window.TRANSLATIONS || {};
          window.TRANSLATIONS[key] = true
          console.log('Window translations', window.TRANSLATIONS);
        },
        nsSeparator: false,
        keySeparator: false,
        returnEmptyString: false,
        interpolation: {
            escapeValue: false, // not needed for react!!
        },
        react: {
            wait: true,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
            //defaultTransParent: Wrapper,
        }
    })


export default i18n;